import script from "./employee-dashboard-latest-payslip.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-dashboard-latest-payslip.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__